import getConfig from 'next/config';

import { Head } from 'shared/page/Head';
import { Main } from 'shared/page/Main';

import { buildCommonProps, sanitizeCommonProps } from '@/server/data/';
import { ResultPage } from '@/scenes/resultPage/ResultPage';
import { ToastProvider } from '@/scenes/resultPage/context/toast/ToastProvider';
import type { NextPage } from 'next';
import type { DeviceType, UnleashToggles } from '@/domain';
import { Hotjar } from 'shared/util/hotjar';
import { fetchSearchId } from '@/api/api';
import logger from '@finn-no/fiaas-logger';
import { WithPricesResultPage } from '@/scenes/resultPage/WithPricesResultPage';
import { FavoriteApiProvider } from '@/context/FavoriteApiProvider';

const {
    publicRuntimeConfig: { baseUrl },
} = getConfig();

interface ResultatProps {
    deviceType: DeviceType;
    loginId: number;
    unleash: UnleashToggles;
    hasLegalBasis: boolean;
    searchId: string | null;
}

const Result: NextPage<ResultatProps> = (props) => {
    return (
        <>
            <Head
                title="Feriehjem og hytter - sammenlign pris | FINN reise"
                description="Finn tusenvis av feriehjem og hytter på et sted!"
                canonical={`${baseUrl}/reise/feriehus-hytteutleie/resultat/`}
            />
            <Main broadcastUrl="/broadcasts?path=www.finn.no/reise/feriehus-hytteutleie">
                <FavoriteApiProvider loginId={props.loginId}>
                    <ToastProvider>
                        {props.searchId !== null ? (
                            <WithPricesResultPage {...props} searchId={props.searchId} />
                        ) : (
                            <ResultPage {...props} />
                        )}
                    </ToastProvider>
                </FavoriteApiProvider>
            </Main>
            <Hotjar enabled={Boolean(props.unleash?.hotjarResultList && props.hasLegalBasis)} />
        </>
    );
};

export const getServerSideProps = async ({ req, res, query }) => {
    const commonProps = await buildCommonProps(req, res, query, true);

    let searchId = null;

    if (commonProps.unleash?.newSearch && query.booking_from && query.booking_to && query.no_of_beds_from) {
        const search = await fetchSearchId(query)
            .then((response) => response)
            .catch((err) => logger.error(err));
        searchId = search.searchId;
    }

    return {
        props: { ...sanitizeCommonProps(commonProps), searchId: searchId ?? null },
    };
};

export default Result;
